import {MenuItem} from "../style/select/Select";

export const selectItem: Array<MenuItem> = [{id : 1, title: "예"}, {id: 2, title: "아니오"}]